// The shop-name rules, mirrored from backend/app/shop_name.py so the
// applicant hears about a problem while typing. The server is the gate: it
// applies the same rules, and also checks the name is not taken.
export const SHOP_NAME_MIN = 3;
export const SHOP_NAME_MAX = 30;
const RESERVED_FRAGMENTS = ["emporia", "mpesa", "safaricom"];

export const normaliseShopName = (raw) => (raw || "").trim().replace(/^@/, "");

// Returns "" when the name is acceptable, or the reason it is not.
export function shopNameProblem(raw) {
  const name = normaliseShopName(raw);
  if (!name) return "Please enter a shop name.";
  if (name.length < SHOP_NAME_MIN || name.length > SHOP_NAME_MAX) {
    return `Your shop name must be ${SHOP_NAME_MIN} to ${SHOP_NAME_MAX} characters.`;
  }
  if (!/^[A-Za-z][A-Za-z0-9._]*$/.test(name)) {
    return 'Your shop name can use letters, numbers, "." and "_", and must start with a letter.';
  }
  if (name.includes("..") || name.endsWith(".")) {
    return 'Your shop name cannot end with "." or have two dots in a row.';
  }
  const squashed = name.toLowerCase().replace(/[._]/g, "");
  if (RESERVED_FRAGMENTS.some((f) => squashed.includes(f))) {
    return "That shop name could be mistaken for Emporia or a payment service. Please choose another.";
  }
  return "";
}

// "@kakaCollections", for display.
export const displayShopName = (name) => `@${normaliseShopName(name)}`;
